exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-submit {\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-end;\n}\n.btn-submit button {\n  padding: 0 48px;\n}\n", ""]);

// exports
